import Instance from "../../../../Axios";

// New Actions for the app

const GetCredTipoCredenciacoes = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/tiposCredenciacoes`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_TIPO_CREDENCIACOES",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredTipoCredenciacoes;
